const { isFunction, isNumber } = require('@hints/utils/types');

/**
 * @typedef {object} InterpretationCondition
 * @property {string} id 
 * @property {number} min
 * @property {number} max
 * @property {(evaluation) => number} value
 * @property {(evaluation) => boolean} callback
 */

/**
 * @typedef {object} Interpretation
 * @property {string} id
 * @property {InterpretationCondition[]} conditions
 */

/**
 * @typedef {object} InterpretorResponse
 * @property {string} interpretationId
 * @property {string} conditionId
 * @property {'none' | 'callback' | 'range'} conditionKind
 * @property {number | undefined} rangeValue
 * @property {number | undefined} rangeMin
 * @property {number | undefined} rangeMax
 */

class Interpretor {
    /**
     * @param {Interpretation[]} interpretations 
     */
    constructor(interpretations) {
        this.interpretations = interpretations;
    }

    /**
     * 
     * @param {*} evaluation 
     * @returns {InterpretorResponse | null}
     */
    interpretScore(evaluation) {
        const allMatchingInterpretations = [];
        for(const interpretation of this.interpretations) {
            const matchingConditions = interpretation.conditions
                .map(c => this.matchAgainstCondition(c, evaluation))
                .filter(c => c.matches);
            if(matchingConditions.length > 0) {
                console.log(`allMatchingInterpretations`, matchingConditions );
                allMatchingInterpretations.push({ interpretationId: interpretation.id, ...matchingConditions[0] });
            }
        }
        return allMatchingInterpretations[allMatchingInterpretations.length - 1];
    }

    /**
     * 
     * @param {InterpretationCondition} condition 
     * @param {any} evaluation 
     * @returns {Omit<InterpretorResponse, 'interpretationId'>}
     */
    matchAgainstCondition(condition, evaluation) {
        if(isFunction(condition.callback)) return _matchCallback(condition, evaluation);
        if(isFunction(condition.value)) return _matchRange(condition, evaluation);
        return _matchNoop(condition);
    }
}

module.exports = Interpretor;

/**
 * 
 * @param {InterpretationCondition} condition 
 * @param {*} evaluation 
 * @returns {Omit<InterpretorResponse, 'interpretationId'>}
 */
function _matchCallback(condition, evaluation) {
    const matches = condition.callback(evaluation);
    return { 
        conditionId: condition.id, 
        conditionKind: 'callback',
        matches: matches, 
        rangeValue: undefined,
        rangeMin: undefined,
        rangeMax: undefined,
    };
}

/**
 * 
 * @param {InterpretationCondition} condition 
 * @param {*} evaluation 
 * @returns {Omit<InterpretorResponse, 'interpretationId'>}
 */
function _matchRange(condition, evaluation) {
    const value = condition.value(evaluation);
    const min = condition.min;
    const max = condition.max;
    const matches = (isNumber(value) && (isNumber(min) && value >= min) && (isNumber(max) && value <= max));
    console.log(`min, max, value`, min, max, value);
    return { 
        conditionId: condition.id, 
        conditionKind: 'range',
        matches: matches, 
        rangeValue: value,
        rangeMin: min,
        rangeMax: max,
    };
}

function _matchNoop(condition) {
        return { 
        conditionId: condition.id, 
        conditionKind: 'none',
        matches: false, 
        rangeValue: undefined,
        rangeMin: undefined,
        rangeMax: undefined,
    };
}